import DataTable from 'components/organisms/data-table'
import SellerOutboundReturnTableColumns from './seller-outbound-return-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'


const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns: PropTypes.arrayOf(PropTypes.string)
}

const defaultProps = {
  isLoading      : false,
  rowButtonProps : {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  }
}

/**
 * Domain-specifc DataTable for Seller Outbound Return
 * @param {object[]} data - array of seller_inbound objects
 * @param {object} pagination - object of pagination data from endpoint
 * @param {func} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 * @param {array} hiddenColumns - Hide specific columns by id
 */
const SellerOutboundReturnTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *
   * we destruct rowButtonProps to make sure this object only render once
   *  */
  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps
  const columns                                                       = useMemo(
    () => SellerOutboundReturnTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

SellerOutboundReturnTable.propTypes    = propTypes
SellerOutboundReturnTable.defaultProps = defaultProps

export default SellerOutboundReturnTable
